/* eslint-disable import/prefer-default-export */
import ParcelexApi from '@/services/parcelex';

export function getNuvemshopData({ orderObjectId, apiKey, hashData }) {
  return ParcelexApi.post(`/nuvemshop/order/${orderObjectId}`, { apiKey, hashData });
}
